/*
 * Campaign times entered in the theme editor as Dutch time ("2026-11-27 00:00"), and the
 * countdown towards them. Shared by the early-access page
 * (assets/collection-early-access.js) and the campaign bar (assets/campaign-bar.js), so
 * both read the same editor value as the same instant.
 */
(function (root) {
  "use strict";

  var TIME_ZONE = "Europe/Amsterdam";

  /* How far Amsterdam is ahead of UTC at a given instant, in milliseconds. */
  function amsterdamOffset(utcMs) {
    var parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: TIME_ZONE,
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).formatToParts(new Date(utcMs));

    var get = function (type) {
      for (var i = 0; i < parts.length; i++)
        if (parts[i].type === type) return Number(parts[i].value);

      return 0;
    };

    var local = Date.UTC(
      get("year"),
      get("month") - 1,
      get("day"),
      get("hour"),
      get("minute"),
      get("second"),
    );

    return local - Math.floor(utcMs / 1000) * 1000;
  }

  /*
   * "2026-11-27 00:00" (or "2026-11-27", or with a T) as Dutch time, to a UTC timestamp.
   * Anything else returns null.
   */
  function parseAmsterdamTime(input) {
    var text = String(input == null ? "" : input).trim();
    var match = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/.exec(text);

    if (!match) return null;
    var y = Number(match[1]);
    var mo = Number(match[2]);
    var d = Number(match[3]);
    var h = Number(match[4] || 0);
    var mi = Number(match[5] || 0);

    if (mo < 1 || mo > 12 || d < 1 || d > 31 || h > 23 || mi > 59) return null;
    var asUtc = Date.UTC(y, mo - 1, d, h, mi);
    var check = new Date(asUtc);

    if (check.getUTCMonth() !== mo - 1 || check.getUTCDate() !== d) return null;
    var guess = asUtc - amsterdamOffset(asUtc);

    return asUtc - amsterdamOffset(guess);
  }

  /* Days, hours, minutes and seconds until the target, or null once it has passed. */
  function remaining(targetMs, nowMs) {
    var ms = targetMs - nowMs;

    if (!(ms > 0)) return null;
    var total = Math.floor(ms / 1000);

    return {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
  }

  root.GbCampaignTime = {
    parseAmsterdamTime: parseAmsterdamTime,
    remaining: remaining,
  };
})(typeof window !== "undefined" ? window : globalThis);
